import { whiteColor, blackColors, successColor, warningColor } from 'assets/jss/material-dashboard-pro-react';

const registerPageStyle = (theme) => ({
	langButton: {
		position: 'absolute',
		top: -50,
		right: 0,
	},
	background: {
		position: 'absolute',
		top: 192,
		right: 3,
		opacity: '0.12',
	},
	logo: {
		marginBottom: 50,
	},
	file: {
		paddingBottom: 16,
	},
	pleaseUpload: {
		marginBottom: 23,
	},
	nextButton: {
		paddingRight: 50,
	},
	page: ({ image }) => ({
		'&::before': {
			display: 'block',
			content: "' '",
			position: 'absolute',
			right: 3,
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'right center',
			opacity: 0.12,
			width: '100%',
			height: '100%',
			backgroundImage: `url(${image})`,
		},
		padding: '32px 81px',
		margin: '72px 10px 60px',
		alignItems: 'flex-start',
		width: '100%',
		'& a': {
			position: 'relative',
			zIndex: 10,
		},
		[theme.breakpoints.down('xs')]: {
			paddingLeft: 10,
			paddingRight: 10,
		},
	}),
	welcome: {
		marginTop: 48,
		marginBottom: 8,
	},
	signUp: {
		marginTop: 24,
		marginBottom: 32,
	},
	tabsWrapper: {
		width: '100%',
	},
	tabsButtons: {
		display: 'flex',
		marginTop: 64,
		marginBottom: 48,
	},
	fullWidth: {
		width: '100%',
	},
	center: {
		textAlign: 'center',
	},
	right: {
		textAlign: 'right',
	},
	grid: {
		width: '100%',
	},
	formSuccessfullySent: {
		marginTop: 16,
		marginBottom: 40,
	},
	request: {
		whiteSpace: 'pre-wrap',
	},
	summaryLink: {
		marginTop: 44,
		marginBottom: 70,
		color: warningColor[0],
		fontFamily: theme.fontFamily.alvar.bold,
		fontSize: theme.fontSize(14),
		display: 'block',
	},
	copyright: {
		color: whiteColor,
		fontSize: theme.fontSize(16),
		lineHeight: 1,
		fontFamily: theme.fontFamily.albert.bold,
		margin: '16px 0 24px',
		position: 'absolute',
		bottom: 0,
		marginLeft: -159,
		[theme.breakpoints.only('xs')]: {
			fontSize: theme.fontSize(12),
			marginLeft: -120,
			left: '50%',
		},
		[theme.breakpoints.only('sm')]: {
			left: '58.3%',
		},
		[theme.breakpoints.only('md')]: {
			left: '66.7%',
		},
		[theme.breakpoints.up('lg')]: {
			left: 'calc(320px + 50%)',
		},
	},
	info: {
		paddingBottom: 50,
	},
	uploadItem: {
		display: 'flex',
		alignItems: 'center',
	},
	download: {
		marginTop: 60,
		marginBottom: 387,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg': {
			position: 'relative',
			bottom: '2px',
			marginRight: '4px',
		},
	},
	uploadContainer: {
		marginBottom: 16,
	},
	upload: {
		width: 'calc(100% - 42px)',
		display: 'inline-block',
		position: 'relative',
	},
	tooltip: {
		padding: 16,
		margin: 0,
	},
	uploadInfo: {
		marginLeft: 18,
		color: blackColors[4],
		zIndex: 2,
		'&:hover': {
			color: blackColors[0],
		},
	},
	deleteIcon: {
		position: 'absolute',
		right: 12,
		top: 0,
	},
	success: {
		color: successColor[0],
		marginRight: 8,
	},
	fileNameContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	filename: {
		margin: 0,
	},
	successIcon: {
		width: 80,
		height: 80,
	},
});

export default registerPageStyle;
